import { getVerticalizedTopBannerText } from "@faire/retailer/components/Notifications/Components/__internal__/getVerticalizedTopBannerText";
import { useFirstOrderIncentiveFormattedData } from "@faire/retailer/hooks/firstOrderIncentive/useFirstOrderIncentiveFormattedData";
import { useFirstOrderIncentiveStore } from "@faire/retailer-visitor-shared/hooks/firstOrderIncentive/useFirstOrderIncentiveStore";
export var useVerticalizedFOITopBannerText = function() {
    var formattedIncentivePercent = useFirstOrderIncentiveFormattedData().formattedIncentivePercent;
    var _useFirstOrderIncentiveStore = useFirstOrderIncentiveStore(), isMaximalistFoi = _useFirstOrderIncentiveStore.isMaximalistFoi, isFirstOrderForFaireDirectIncentive = _useFirstOrderIncentiveStore.isFirstOrderForFaireDirectIncentive;
    return getVerticalizedTopBannerText({
        formattedIncentivePercentNumber: formattedIncentivePercent,
        isMaximalistFoi: isMaximalistFoi,
        isFoiForFD: isFirstOrderForFaireDirectIncentive
    });
};
